export const AppConstants = {
    SERVER_CONFIG: {
      URL:'https://stagingapi.lumenci.ai'
      },
}